import { Blockchain } from "@rarible/api-client"
import { fraxtal } from "viem/chains"
import { toCurrencyId } from "../../../price/types"
import { FEE_CONFIG_URL } from "../constants"
import type { StaticEthereumBlockchainConfig } from "../types"

export const fraxtalConfig: StaticEthereumBlockchainConfig = {
  name: "Fraxtal",
  icon: "/images/blockchains/fraxtal.svg",
  isEvm: true,
  testnet: false,
  isTestnet: false,
  feesVersion: "v3",
  treasury: "0x64d34BcfC32Fb663172C47d6E4Fb1dBFaba6e7a2",
  unionApi: "https://api.rarible.org",
  basePath: "https://fraxtal-api.rarible.org",
  chainId: 252,
  blockchain: Blockchain.FRAXTAL,
  chainName: "Fraxtal",
  exchange: {
    v2: "0x2c46e116a742C159fa79e2717b50759EC979e3Be",
    wrapper: "0x4421b444955b50e57fa2F73656A5bD1E23F9B9e5",
  },
  blockExplorers: [
    {
      url: "https://fraxscan.com/",
      icon: "/images/scanner.svg",
      adress: "https://fraxscan.com/address/${adrress}",
    },
  ],
  rpcUrls: [{ url: "https://rpc.frax.com", isPublic: true }],
  privateRpcNodeSlug: "fraxtal-node",
  transferProxies: {
    nft: "0x892f0e3DEaC041b12b748bf9d7D1BA480d266696",
    erc721Lazy: "0x147d06FbDA085C0455615E554D87262B0726ad0c",
    erc20: "0x12181eDedD1f81838580668bb5B50e1030df4667",
  },
  feeConfigUrl: FEE_CONFIG_URL,
  primaryCurrency: {
    id: toCurrencyId("FRAXTAL:0x0000000000000000000000000000000000000000"),
    symbol: "FRAX",
    name: "FRAX",
    decimals: 18,
  },
  wrappedCurrency: {
    id: toCurrencyId("FRAXTAL:0xfc00000000000000000000000000000000000002"),
    symbol: "WFRAX",
    name: "WFRAX",
    decimals: 18,
  },
  addFundsLink: "",
  hasStabilityProtocol: true,
  viem: fraxtal,
}

export const getFraxtalConfig = (): StaticEthereumBlockchainConfig =>
  fraxtalConfig
